
<template>
  <!--会员详情-->
  <div class="advanced-form">
    <a-form layout="vertical">
      <div class="card">
        <div class="card-head">
          <h3>基本信息</h3>
        </div>
        <div class="card-body">
          <a-row type="flex">
            <a-col v-for="(item, index) of baseInfo" :key="index" :span="8">
              <a-form-item class="value-indent" :label="item.label">
                <div class="pic-box absolute" v-if="item.key==='avatarUrl'">
                  <img :src="item.value" alt="">
                </div>
                <span v-else class="ant-form-text">{{item.value}}</span>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </div>
    </a-form>

    <div class="card">
      <div class="card-head">
        <h3>住房信息</h3>
      </div>
      <div class="card-body">
        <x-tabula
          ref="table"
          :searchList="[]"
          rowKey="householder_info_id"
          :columns="columns"
          :listApi="listApi"
          :rowSelection="false"
        >
          <template slot="opt_expireTime" slot-scope="{row}">
            <span>{{row.expireTime | foreverTime}}</span>
          </template>
        </x-tabula>
      </div>
    </div>

    <div class="card">
      <div class="card-head">
        <h3>登录记录</h3>
      </div>
      <div class="card-body">
        <x-tabula
          ref="table"
          rowKey="id"
          :columns="loginColumns"
          :listApi="loginListApi"
          :rowSelection="false"
        >
        </x-tabula>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'memberDetail',
  data () {
    return {
      listApi: {
        url: '',
        resHandle: '',
        searchHandle: ''
      },
      loginListApi: {
        url: '',
        resHandle: '',
        searchHandle: ''
      },

      baseInfo: [
        {key: 'nickName', label: '昵称', value: ''},
        {key: 'mobilePhone', label: '手机号', value: ''},
        {key: 'avatarUrl', label: '头像', value: ''},
        {key: 'sexDesc', label: '性别', value: ''},
        {key: 'birthday', label: '出生年月', value: ''},
        {key: '', label: '', value: ''}, // 填充
        {key: 'fromModeDesc', label: '注册来源', value: ''},
        {key: 'fromOsDesc', label: '注册平台', value: ''},
        {key: '', label: '', value: ''}, // 填充
        {key: 'createTime', label: '注册时间', value: ''},
        {key: 'postIp', label: '注册IP', value: ''},
        {key: 'isBindWeixinDesc', label: '微信绑定', value: ''},
        {key: 'lastLoginTime', label: '最后登录时间', value: ''},
        {key: 'lastLoginIp', label: '最后登录IP', value: ''},
        {key: 'loginNums', label: '登录次数', value: ''},
        {key: 'isGetFaceDesc', label: '是否采集人脸', value: ''},
        {key: 'isGetEigenvalueDesc', label: '是否有特征值', value: ''},
        {key: 'faceUpdateTime', label: '人脸更新时间', value: ''}
      ],
      columns: [
        { title: '所在城市', dataIndex: 'area', align: 'left', width: '' },
        { title: '小区', dataIndex: 'communityName', align: 'left', width: '' },
        { title: '房间', dataIndex: 'roomAddress', align: 'left', width: '' },
        { title: '住户类型', dataIndex: 'householdTypeDesc', align: 'left', width: '' },
        { title: '到期时间', dataIndex: 'expireTime', align: 'left', width: '', scopedSlots: {customRender: 'expireTime'} }
      ],
      loginColumns: [
        { title: '登录时间', dataIndex: 'createTime', align: 'left', width: '' },
        { title: '设备机型', dataIndex: 'brandModel', align: 'left', width: '' },
        { title: '设备版本', dataIndex: 'appOs', align: 'left', width: '' },
        { title: '联网方式', dataIndex: 'netModel', align: 'left', width: '' },
        { title: '登录地域', dataIndex: 'region', align: 'left', width: '' }
      ],
      tableData: []
    };
  },
  created () {
    this.listApi.url = `/member/rooms/${this.$route.query.id}`;
    this.loginListApi.url = `/member/logs/${this.$route.query.id}`;
    this.getDetail();
  },
  mounted () {
  },
  methods: {
    getDetail () {
      this.$get({
        url: `/member/${this.$route.query.id}`,
        params: {}
      }).then(({data}) => {
        for (let item in data) {
          this.baseInfo.forEach((el) => {
            if (el.key === item) {
              el.value = data[item];
            }
          });
        }
      });
    }
  }
};
</script>
